import * as XLSX from "xlsx";

const formatMinutesAndSeconds = (seconds) => {
  const totalSeconds = Math.max(0, Math.floor(Number(seconds) || 0));
  const minutes = Math.floor(totalSeconds / 60);
  const remainingSeconds = totalSeconds % 60;

  return `${String(minutes).padStart(2, "0")}:${String(remainingSeconds).padStart(2, "0")}`;
};

const getDescription = (region, field) => {
  const description = region.data?.description;

  if (description?.[field] !== undefined && description?.[field] !== null) {
    return description[field];
  }

  return region.data?.caption ?? "";
};

const getComment = (region) => {
  const comment = region.data?.review?.comment;
  return Array.isArray(comment) ? comment[0] ?? "" : comment ?? "";
};

const safeFileName = (name) => (name || "project")
  .replace(/[\\/:*?"<>|]/g, "_")
  .trim();

export const exportQCComments = (regions, projectName) => {
  const rows = [...regions]
    .sort((first, second) => first.start - second.start)
    .map((region, index) => ({
      "Segment": index + 1,
      "Start (mm:ss)": formatMinutesAndSeconds(region.start),
      "End (mm:ss)": formatMinutesAndSeconds(region.end),
      "Original description": getDescription(region, "preview"),
      "Current description": getDescription(region, "initial"),
      "QC comment": getComment(region),
    }));

  const worksheet = XLSX.utils.json_to_sheet(rows);
  worksheet["!cols"] = [
    { wch: 10 },
    { wch: 16 },
    { wch: 14 },
    { wch: 55 },
    { wch: 55 },
    { wch: 55 },
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "QC Comments");
  XLSX.writeFile(workbook, `${safeFileName(projectName)}_QC_comments.xlsx`);
};
